import React, { useEffect, useState } from "react";
import { FormTextInputAutoSuggest } from "../../../components/common";

import { Search } from "../../../components/common/Icons";
import { useDogSearchApi } from "../../../context";

export interface FormTextInputAutoSuggestProps {
	className: string;
	name: string;
	placeholder: string;
}

export const BreedInput: React.FC<FormTextInputAutoSuggestProps> = ({
	className,
	name,
	placeholder,
}) => {
	const [searchTerm, setSearchTerm] = useState("");
	const { useDogSearchQuery, onSearchBreedList } = useDogSearchApi();

	// biome-ignore lint/correctness/useExhaustiveDependencies: We only want this to run once
	useEffect(() => {
		useDogSearchQuery();
	}, []);

	const onInputChange = (value: string) => {
		onSearchBreedList(value);
		setSearchTerm(value);
	};
	return (
		<FormTextInputAutoSuggest
			className={className}
			name={name}
			placeholder={placeholder}
			suggestions={[]}
			inputValue={searchTerm}
			IconLeft={Search}
			onIconRightCallback={() => {}}
			onChangeCallback={onInputChange}
		/>
	);
};

export default BreedInput;
